export const LIVE_LECTURE_1_CONSTANTS = {
    DEFAULT_ROW: {
        id: "1",
        status: false,
        title: "Live Lectures",
        title_text_color: "#1F2937",
        component_background_color: "#F9FAFB",
        day_section_color: "#FFFFFF",
        day_text_color: "#1F2937",
        view_button_text_color: "#374151",
        view_button_bg_color: "#FFFFFF",
        view_button_active_bg_color: "#3B82F6",
        view_button_active_text_color: "#FFFFFF",
        active_bar_color: "#3B82F6",
        navigate_button_color: "#374151",
        left_navigate_icon: "",
        right_navigate_icon: "",
        button_icon: "",
        button_text: "View All",
        button_text_color: "#FFFFFF",
        button_bg_color: "#3B82F6",
        event_color: "#10B981",
        event_text_color: "#1F2937",
        tooltip_color: "#1F2937",
        tooltip_text_color: "#FFFFFF",
        description: "",
    },

    LIVE_LECTURE_FIELDS_CONFIG: [
        {
            fieldName: "status",
            label: "Live Lecture Status",
            value: false,
            valueType: "boolean",
            filedType: "TOGGLE",
            placeholder: "Enable or disable live lecture widget",
        },
        {
            fieldName: "title",
            label: "Title",
            value: "Live Lectures",
            valueType: "string",
            filedType: "INPUT",
            placeholder: "Enter widget title",
            required: true,
        },
        {
            fieldName: "title_text_color",
            label: "Title Text Color",
            value: "#1F2937",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter title text color (e.g., #1F2937)",
        },
        {
            fieldName: "component_background_color",
            label: "Component Background Color",
            value: "#F9FAFB",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter component background color (e.g., #F9FAFB)",
        },
        {
            fieldName: "day_section_color",
            label: "Day or Week Section Color",
            value: "#FFFFFF",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter day section background color (e.g., #FFFFFF)",
        },
        {
            fieldName: "day_text_color",
            label: "Day or Month Text Color",
            value: "#1F2937",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter day text color (e.g., #1F2937)",
        },
        {
            fieldName: "view_button_text_color",
            label: "View Button Text Color",
            value: "#374151",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter view button text color (e.g., #374151)",
        },
        {
            fieldName: "view_button_bg_color",
            label: "View Button Background Color",
            value: "#FFFFFF",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter view button background color (e.g., #FFFFFF)",
        },
        {
            fieldName: "view_button_active_bg_color",
            label: "View Button Active Background Color",
            value: "#3B82F6",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter active view button background color (e.g., #3B82F6)",
        },
        {
            fieldName: "view_button_active_text_color",
            label: "View Button Active Text Color",
            value: "#FFFFFF",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter active view button text color (e.g., #FFFFFF)",
        },
        {
            fieldName: "active_bar_color",
            label: "Active Bar Color",
            value: "#3B82F6",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter active bar color (e.g., #3B82F6)",
        },
        {
            fieldName: "navigate_button_color",
            label: "Navigate Button Color",
            value: "#374151",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter left/right navigate button color (e.g., #374151)",
        },
        {
            fieldName: "left_navigate_icon",
            label: "Left Navigate Icon",
            value: "",
            valueType: "string",
            filedType: "FILE",
            placeholder: "Upload left navigation icon (optional)",
        },
        {
            fieldName: "right_navigate_icon",
            label: "Right Navigate Icon",
            value: "",
            valueType: "string",
            filedType: "FILE",
            placeholder: "Upload right navigation icon (optional)",
        },
        {
            fieldName: "button_icon",
            label: "Button Icon",
            value: "",
            valueType: "string",
            filedType: "FILE",
            placeholder: "Upload button icon (optional)",
        },
        {
            fieldName: "button_text",
            label: "Button Text",
            value: "View All",
            valueType: "string",
            filedType: "INPUT",
            placeholder: "Enter button text (e.g., View All)",
        },
        {
            fieldName: "button_text_color",
            label: "Button Text Color",
            value: "#FFFFFF",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter button text color (e.g., #FFFFFF)",
        },
        {
            fieldName: "button_bg_color",
            label: "Button Background Color",
            value: "#3B82F6",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter button background color (e.g., #3B82F6)",
        },
        {
            fieldName: "event_color",
            label: "Event Color",
            value: "#10B981",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter event indicator color (e.g., #10B981)",
        },
        {
            fieldName: "event_text_color",
            label: "Event Text Color",
            value: "#1F2937",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter event text color (e.g., #1F2937)",
        },
        {
            fieldName: "tooltip_color",
            label: "Tooltip Background Color",
            value: "#1F2937",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter tooltip background color (e.g., #1F2937)",
        },
        {
            fieldName: "tooltip_text_color",
            label: "Tooltip Text Color",
            value: "#FFFFFF",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter tooltip text color (e.g., #FFFFFF)",
        },
        {
            fieldName: "description",
            label: "Description",
            value: "",
            valueType: "string",
            filedType: "RICH_TEXT_EDITOR",
            placeholder: "Enter description for live lecture section",
        },
    ],
};

